import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify'; // Importa o Toastify
import 'react-toastify/dist/ReactToastify.css'; // Importa o CSS do Toastify
import './Register.css';

const API_URL = process.env.REACT_APP_API_URL;

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState('');
  const [progressBarColor, setProgressBarColor] = useState('');
  const [progressBarWidth, setProgressBarWidth] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_URL}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, email, password }),
      });
      const data = await response.json();
      if (response.ok) {
        toast.success('Usuário cadastrado com sucesso!', {
          position: 'top-right', // Corrige o uso do POSITION
        });
        setTimeout(() => navigate('/'), 3000); // Redireciona após 3 segundos
      } else {
        toast.error(data.detail || 'Erro ao cadastrar', {
          position: 'top-right', // Corrige o uso do POSITION
        });
      }
    } catch (error) {
      toast.error('Erro ao conectar ao servidor', {
        position: 'top-right', // Corrige o uso do POSITION
      });
    }
  };

  const checkPasswordStrength = (password) => {
    if (password.length < 6) {
      setPasswordStrength('Fraca');
      setProgressBarColor('red');
      setProgressBarWidth(25);
    } else if (
      /[A-Z]/.test(password) &&
      /[0-9]/.test(password) &&
      /[!@#$%^&*]/.test(password)
    ) {
      setPasswordStrength('Forte');
      setProgressBarColor('green');
      setProgressBarWidth(100);
    } else if (password.length >= 6) {
      setPasswordStrength('Média');
      setProgressBarColor('orange');
      setProgressBarWidth(50);
    } else {
      setPasswordStrength('');
      setProgressBarColor('');
      setProgressBarWidth(0);
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    checkPasswordStrength(newPassword);
  };

  return (
    <div className="login-container">
      <div className="login-form-container">
        <h1>CSC Tracking</h1>
        <h3>Cadastro</h3>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-field">
            <label>Usuário</label>
            <input
              type="text"
              placeholder="Escolha um nome de usuário"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="login-field">
            <label>E-mail</label>
            <input
              type="email"
              placeholder="seuemail@exemplo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="login-field password-field">
            <label>Senha</label>
            <div className="password-container">
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Crie uma senha"
                value={password}
                onChange={handlePasswordChange}
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{
                  width: `${progressBarWidth}%`,
                  backgroundColor: progressBarColor,
                }}
              ></div>
            </div>
            <p className={`password-strength ${passwordStrength.toLowerCase()}`}>
              {passwordStrength && `Senha: ${passwordStrength}`}
            </p>
          </div>
          <button type="submit" className="login-button">Cadastrar</button>
          <p className="signup-link">
            Já tem conta? <Link to="/">Voltar para Login</Link>
          </p>
        </form>
      </div>
      <div className="login-image-container">
        <img src="https://i.ibb.co/mvrkv7R/Background.png" alt="Ilustração de Cadastro" />
      </div>
    </div>
  );
}

export default Register;
